/* eslint-disable jira/naming/disallow-filenames */

import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { Field } from './FieldEdge.types.tsx';

const PAGE_SIZE = 100;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type Handler = (promise: Promise<any>) => Promise<Field[]>;

export const fetchFields = async (
	query: string,
	handler: Handler,
	params?: { [key: string]: string },
): Promise<Field[] | null> => {
	try {
		const promise = performPostRequest('/gateway/api/graphql', {
			body: JSON.stringify({
				query,
				variables: {
					first: PAGE_SIZE,
					...params,
				},
			}),
			headers: {
				'content-type': 'application/json',
				'X-ExperimentalApi': 'JiraJqlBuilder',
			},
		});

		return await handler(promise);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		log.safeErrorWithoutCustomerData(
			'jiraRouterResourcesBusinessFields',
			'Something went wrong while fetching fields',
		);

		const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
		if (!isClientError) {
			fireErrorAnalytics({
				meta: {
					id: 'fieldsResource',
					packageName: 'jiraRouterResourcesBusinessFields',
					teamName: 'wanjel',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}
	}

	return null;
};
